import React, { useEffect, useState } from "react"
import BackgroundImage from "../components/background-images"
import Footer from "../components/footer"
import Header from "../components/header"
import SEO from "../components/seo"

export const AllowedLink = {
  ambassador: "https://tabea659854.typeform.com/to/lD69PD33",
}

export interface Props {
  location: any
}

/**
 *
 */
const Iframe = ({ location }: Props) => {
  const [link, setLink] = useState<string>()

  useEffect(() => {
    const { search } = location
    const params = new URLSearchParams(search)
    const link = params.get("link")

    if (Object.values(AllowedLink).includes(link)) {
      setLink(link)
    }
  }, [location])

  return (
    <BackgroundImage>
      <SEO />

      <Header />

      <div
        className="container-fluid"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <iframe
          title="Folo"
          src={link}
          style={{
            width: "100%",
            height: "80%",
            border: "none",
          }}
        />
      </div>

      <Footer />
    </BackgroundImage>
  )
}

export default Iframe
